import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";
var SvgClockAlt = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 24 : _b, props = __rest(_a, ["size"]);
    return (React.createElement(Svg, __assign({ fill: "currentColor", viewBox: "0 0 25 24", size: size }, props),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M.76 12c0-6.627 5.373-12 12-12 6.625.008 11.993 5.376 12 12 0 6.627-5.372 12-12 12-6.627 0-12-5.373-12-12zm2 0c0 5.523 4.478 10 10 10 5.521-.006 9.995-4.48 10-10 0-5.523-4.476-10-10-10-5.522 0-10 4.477-10 10z", clipRule: "evenodd" }),
        React.createElement("path", { fill: "currentColor", d: "M17.895 15.81l-4.634-4.249V6.5a1 1 0 10-2 0V12a1 1 0 00.324.738l4.959 4.545a1.01 1.01 0 001.413-.061 1 1 0 00-.062-1.412z" })));
};
export default SvgClockAlt;
//# sourceMappingURL=ClockAlt.js.map